import React, { useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router-dom";
import Chat from "./Chat";

function LayoutApp() {

  function getCookie(name) {
    return document.cookie
      .split("; ")
      .find(row => row.startsWith(name + "="))
      ?.split("=")[1];
  }

  const [userName, setUserName] = React.useState("");
  const [avatar, setAvatar] = React.useState(() => {
    return sessionStorage.getItem("avatar") || "/images/monkey.png";
  });
  const [open, setOpen] = React.useState(false);

  const navigate = useNavigate();

  const [avatarSelectorOpen, setAvatarSelectorOpen] = React.useState(false);

  const handleAvatarClick = () => setAvatarSelectorOpen(true);

  const handleAvatarSelect = (img) => {
    const path = `/images/${img}`;
    setAvatar(path);
    sessionStorage.setItem("avatar", path);
    setAvatarSelectorOpen(false);
  };


  useEffect(() => {
    const storedUser = sessionStorage.getItem("username");
    if (storedUser) {
      setUserName(storedUser);
    }
  }, []);

  const handleLogout = async () => {
    const csrfToken = getCookie("csrf_token");

    await fetch("https://api.datasenseai-neuronize.charlizeonline.net/api/auth/logout", {
      method: "POST",
      credentials: "include",
      headers: {
        "X-CSRF-Token": csrfToken,
      },
    });

    sessionStorage.clear();
    navigate("/");
  };


  const defaultTheme = createTheme({
    palette: {
      primary: {
        main: "#44B8AC",
      },
      secondary: {
        main: "#006f66",
      },
    },
  });

  const handleClose = () => setOpen(false);

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <GlobalStyles
        styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <AppBar position="static" color="inherit" elevation={0}>
          <Toolbar
            sx={{
              p: { xs: 0.5, sm: 1 },
              m: 0,
              minHeight: { xs: 44, sm: 52 },
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
              flexWrap: "nowrap",
              overflow: "hidden",
              width: "100%",
              border: "1px solid gray",
              backgroundColor: "#fafafaff",
            }}
          >
            <Typography
              variant="body2"
              noWrap
              sx={{
                fontFamily: "Roboto, Arial",
                color: "#01579B",
                fontSize: { xs: "0.775rem", sm: "0.9rem", md: "1.1rem" },
                fontWeight: 500,
                minWidth: 0,
                maxWidth: { xs: 200, sm: 300 },
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                flexShrink: 1,
              }}
            >
              Neuronize - Analyst Agent
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                minWidth: 0,
                flexShrink: 1,
                overflow: "hidden",
                borderRadius: "8px",
                transition: "all 0.2s ease-in-out",
              }}
            >
              <Avatar
                src={avatar}
                onClick={handleAvatarClick}
                sx={{
                  width: 32,
                  height: 32,
                  cursor: "pointer",
                  border: "2px solid #44B8AC",
                  flexShrink: 0,
                }}
              />
              <Typography
                variant="body2"
                noWrap
                sx={{
                  fontFamily: "Roboto, Arial",
                  fontWeight: 500,
                  fontSize: { xs: "0.775rem", sm: "0.9rem", md: "1.1rem" },
                  color: "#01579B",
                  minWidth: 0,
                  maxWidth: { xs: 120, sm: 200 },
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  flexGrow: 1,
                }}
              >
                {userName || "Usuario"}
              </Typography>
              <Button
                variant="outlined"
                onClick={handleLogout}
                sx={{
                  borderColor: "#01579B",
                  color: "#01579B",
                  fontFamily: "Roboto, Arial",
                  fontSize: { xs: "0.7rem", sm: "0.85rem", md: "1rem" },
                  minWidth: 70,
                  px: 1,
                  py: 0.2,
                  height: 30,
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                  "&:hover": {
                    borderColor: "#44B8AC",
                    backgroundColor: "#f0fdfd",
                  },
                }}
              >
                Logout
              </Button>
            </Box>
          </Toolbar>
        </AppBar>

        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
          <Container
            disableGutters
            maxWidth="lg"
            component="main"
            sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
          >
            <Chat userName={userName} />
          </Container>
        </Box>

        <Box textAlign="center">
          <Typography
            variant="body2"
            sx={{
              pb: 1,
              px: 2,
              fontSize: { xs: "0.775rem", sm: "0.9rem", md: "1.2rem" },
            }}
          >
            © 2025 All rights reserved.
          </Typography>
        </Box>
      </Box>
      <Dialog open={avatarSelectorOpen} onClose={() => setAvatarSelectorOpen(false)}>
        <DialogTitle>Selecciona tu avatar</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            {["monkey.png", "man.png", "boy.png", "gamer.png", "woman.png", "woman (1).png", "avatar.png", "meerkat.png"].map((img) => (
              <Avatar
                key={img}
                src={`/images/${img}`}
                sx={{
                  width: 48,
                  height: 48,
                  cursor: "pointer",
                  border: avatar === `/images/${img}` ? "2px solid #44B8AC" : "none",
                }}
                onClick={() => handleAvatarSelect(img)}
              />
            ))}
          </Box>
        </DialogContent>
      </Dialog>

    </ThemeProvider>
  );
}

export default LayoutApp;